import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDateParserFormatter, NgbDatepicker, NgbModal, NgbModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTablesModule } from 'angular-datatables';
import { SessionService } from '../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { LocationServiceService } from '../../Model/LocationMaster/location-service.service';
import { CommonService } from '../../Model/Common/common.service';
import { AdditionOfManpowerService } from '../../Model/AdditionReductionOfManpower/addition-of-manpower.service';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { ComboService } from '../../Model/Combo/combo.service';
import { UtilityService } from '../../Model/utility/utility.service';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';

@Component({
  selector: 'app-view-of-allocate-manpower',
  standalone: true,
  imports: [NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, NgbPaginationModule, CommonModule, NgbDatepicker, DataTablesModule, LoaderComponent],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './view-of-allocate-manpower.component.html',
  styleUrl: './view-of-allocate-manpower.component.scss'
})
export class ViewOfAllocateManpowerComponent {
  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  ViewDataObj: any[] = [];
  BranchMaster: any[] = [];
  ClientLoad: any[] = [];
  SiteLoad: any[] = [];
  BranchId: number = 0;
  BranchName: string = '';
  ClientId: number = 0;
  ClientName: string = '';
  SiteId: number = 0;
  SiteName: string = '';
  SiteCode: string = '';
  Total: number = 0;
  Id: number = 0;
  selectcheck: boolean = false;
  dt: any = null;
  dtobj : any = null;
  AsOnDate: any = null
  objdata = {
    bid: 0,
    cid: 0,
    sid: 0,
  }
  dtoptions: DataTables.Settings = {};
  constructor(
    private router: Router,
    private sessionService: SessionService,
    private toast: ToastService,
    private siteadditionreduction: AdditionOfManpowerService,
    private route: ActivatedRoute,
    protected common: CommonService,
    private tooltip: TooltipService,
    private comboload: ComboService,
    private utility: UtilityService,
    private dateFormate: CustomDateParserFormatter,
  ) {
    this.common.getPageRights();
    //this.CurDate('RegistrationDate');
    this.dtoptions = { ...this.common.commonDToptions };
  }
  ngOnInit(): void {
    this.ComboLoad('Branch'); 
    this.initializeData();
  }

  initializeData(): void {
    this.route.queryParams.subscribe(params => {
      this.handleQueryParams(params);
      this.loadInitialData();
    });
  }
  handleQueryParams(params: any): void {
    this.Id = params['sid'];
    this.objdata = {
      bid: parseInt(params['bid']),
      cid: parseInt(params['cid']),
      sid: parseInt(params['sid']),   
    };
    this.dt = params['Date'];
    this.dtobj = this.dateFormate.parse(this.dt);
    this.SiteId = this.Id;
  }

  loadInitialData(): void {
    this.Loadata();
    this.Load();
    //this.Count();
  }
  //Above are for optimization 

  Loadata() {
    // this.ComboLoad('Branch');
    this.BranchId = this.objdata.bid;
    this.ComboLoad('Client');
    this.ClientId = this.objdata.cid;
    this.ComboLoad('Site');
    this.SiteId = this.objdata.sid
    //this.Count();
  }
  
  // CurDate(SelectType: string) {
  //   return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': '', 'JoiningDate': '', }).subscribe({
  //     next: (response) => {
  //       if (SelectType == 'RegistrationDate') {
  //         this.AsOnDate = response.Table[0].RegistrationDate;
  //       }
  //     },
  //     complete: () => { },
  //     error: (error) => { },
  //   });
  // }
  
  Load() {
    const data = {
      SelectType: 'View',
      ESS_ShiftWiseManpowerDetailsId: 0,
      AllocationType: '',
      WoNo: '',
      SiteId: this.Id,
      DesignationId: '',
      DutyId: '',
      ShiftId: '',
      AsOnDate: this.dt
    }
    console.log('date ', this.dt);
    this.isDisabled = true;
    this.siteadditionreduction.ESS_SiteManpowerAdditionReductionGet(data).subscribe(
      data => {
        if (data && data.Table && data.Table.length > 0) {
          this.ViewDataObj = Object.values(data.Table);
          this.isDisabled = false;
          //this.dtTrigger.next(null);
        }
        else {
          this.isDisabled = false;
          this.ViewDataObj = [];
        }
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false;
      }
    );
  }

  AdditionandReduction(type: string) {
    let navigationID: NavigationExtras = {
      queryParams: {
        Type: 'V',
      }
    };
    if (type == 'Addition') {
      this.router.navigate(['master/AdditionOfManpower'], navigationID);
    }
    else if (type == 'Reduction') {
      this.router.navigate(['master/ReductionOfManpower'], navigationID);
    }
  }
  onEditClick(element: any): void {
    let navigationID: NavigationExtras = {
      queryParams: {
        editMode: true,
        AllocationType: element.AllocationType,
        Id: element.ESS_ShiftWiseManpowerMasterId,
        wono: element.WONo,
        Date: this.AsOnDate,
        Type: 'V',
        Auto: element.IsAutoReduction ? 'A' : ''
      }
    };
    if (element.AllocationType === 'A' || element.AllocationType === 'O') {
      this.router.navigate(['master/AdditionOfManpower'], navigationID);
    }
    else if (element.AllocationType === 'R') {
      this.router.navigate(['master/ReductionOfManpower'], navigationID);
    }
  }

  onSelectChange(type: string) {
    if (type === 'Branch') {
      const selected = this.BranchMaster.find(duty => duty.BranchMasterID === this.BranchId);
      this.BranchName = selected ? selected.BranchName : null;
      this.ClientId = 0;
      this.ClientName = ''
      this.SiteCode = ''
      this.SiteName = ''
      this.SiteId = 0
      this.ViewDataObj = [];
    }
    else if (type == 'Client') {
      const selected = this.ClientLoad.find(site => site.ClientGroupMasterID === this.ClientId);
      this.ClientName = selected ? selected.ClientGroupName : null;
      this.SiteCode = ''
      this.SiteName = ''
      this.SiteId = 0
      this.ViewDataObj = [];
    }
    else if (type === 'Site') {
      const selected = this.SiteLoad.find(duty => duty.SiteMasterID === this.SiteId);
      this.SiteName = selected ? selected.SiteName : null;
      this.SiteCode = selected ? selected.SiteCode : null;
      this.ViewDataObj = [];
      //this.Count();
    }
  }
  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.isDisabled = true
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'Client' || Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty') ? this.BranchId : 0,
      'ClientId': (Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty') ? this.ClientId : 0,
      'SiteId': (Combotype == 'Designation' || Combotype == 'Duty') ? this.SiteId : 0,
    }).subscribe({
      next: (response) => {
        if (response.ComboLoad.length >= 0) {
          if (Combotype == 'Branch') {
            this.BranchMaster = response.ComboLoad;
            const selected = this.BranchMaster.find(duty => duty.BranchMasterID === this.BranchId);
            this.BranchName = selected ? selected.BranchName : null;

          } else if (Combotype == 'Client') {
            this.ClientLoad = response.ComboLoad;
            const selected = this.ClientLoad.find(site => site.ClientGroupMasterID === this.ClientId);
            this.ClientName = selected ? selected.ClientGroupName : null;

          } else if (Combotype == 'Site') {
            this.SiteLoad = response.ComboLoad;
            const selected = this.SiteLoad.find(duty => duty.SiteMasterID === this.SiteId);
            this.SiteName = selected ? selected.SiteName : null;
            this.SiteCode = selected ? selected.SiteCode : null;
          }
        }
        else {

        }
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  add() {
    this.dt = this.dateFormate.format(this.dtobj);
    const data = {
      SelectType: 'View',
      ESS_ShiftWiseManpowerDetailsId: 0,
      AllocationType: '',
      WoNo: '',
      SiteId: this.SiteId,
      DesignationId: '',
      DutyId: '',
      ShiftId: '',
      AsOnDate: this.selectcheck ? '' : this.dt
    }
    console.log('daa', data);
    this.isDisabled = true;
    this.siteadditionreduction.ESS_SiteManpowerAdditionReductionGet(data).subscribe(
      data => {
        if (data && data.Table && data.Table.length > 0) {
          this.ViewDataObj = Object.values(data.Table);
          this.isDisabled = false;
          //this.dtTrigger.next(null);
        }
        else {
          this.isDisabled = false;
          this.ViewDataObj = [];
        }
       // this.Count();
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false;
      }
    );
  }

  // Count() {
  //   const data = {
  //     SelectType: 'Count',
  //     RegionId: '',
  //     BranchId: this.BranchId,
  //     ZoneId: '',
  //     ClientId: this.ClientId,
  //     SiteId: this.SiteId,
  //     SupervisorId: '',
  //     AsOnDate: this.AsOnDate
  //   }
  //   this.isDisabled = true;
  //   this.siteadditionreduction.ESS_SiteManpowerSummary(data).subscribe(
  //     data => {
  //       if (data && data.Table && data.Table.length > 0) {
  //         this.Total = data.Table[0].NoOfPerson;
  //       }
  //       else {
  //         this.isDisabled = false;
  //       }
  //       this.isDisabled = false
  //     },
  //     error => {
  //       console.error('Error:', error);
  //       this.isDisabled = false;
  //     }
  //   );
  // }
  refresh() {
    this.router.navigate(['master/sitewisemanpowersummary']);
  }

  // toggleSelect() {
  //   if (this.selectcheck) {
  //     const data = {
  //       SelectType: 'View',
  //       ESS_ShiftWiseManpowerDetailsId: 0,
  //       AllocationType: '',
  //       WoNo: '',
  //       SiteId: this.SiteId,
  //       DesignationId: '',
  //       DutyId: '',
  //       ShiftId: '',
  //       AsOnDate: ''
  //     }
  //     this.isDisabled = true;
  //     this.siteadditionreduction.ESS_SiteManpowerAdditionReductionGet(data).subscribe(
  //       data => {
  //         if (data && data.Table && data.Table.length > 0) {
  //           this.ViewDataObj = Object.values(data.Table);
  //         }
  //         else {
  //           this.toast.show({ message: 'Data not found!', type: toastTypeEnum.warning });
  //           this.isDisabled = false;
  //           this.ViewDataObj = [];
  //         }
  //         this.isDisabled = false
  //       },
  //       error => {
  //         console.error('Error:', error);
  //         this.isDisabled = false;
  //       }
  //     );
  //   }
  //   else if (!this.selectcheck) {
  //     this.add();
  //   }

  // } (change)="toggleSelect()"

  toggleSelect(){
    if (this.selectcheck){
      // this.dt = null;
      // this.dtobj = null;
    }
    else{
      //this.dt
    }
  }
}
